const isFirefox = navigator.userAgent.match(/firefox/i) != null;

const isSafari = navigator.vendor &&
                 navigator.vendor.indexOf('Apple') > -1 &&
                 navigator.userAgent &&
                 !navigator.userAgent.match('CriOS');

const isIpad = navigator.userAgent.match(/iPad/i) != null;

const isIphone = navigator.userAgent.match(/iPhone/i) != null ||
                 navigator.userAgent.match(/iPod/i) != null;

export default {isFirefox, isSafari, isIpad, isIphone}



// WEBPACK FOOTER //
// ./ua-detect.js